"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const formik_1 = require("formik");
const utilities_1 = __importStar(require("jsAssets/utilities"));
const lodash_1 = require("lodash");
const find_1 = __importDefault(require("lodash/find"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const client_1 = require("react-dom/client");
const notification_1 = __importDefault(require("../reviews/constants/notification"));
const helper_1 = require("../reviews/helper");
const CreateReviewContent_1 = __importDefault(require("./components/CreateReviewContent"));
const FooterComponent_1 = __importDefault(require("./components/FooterComponent"));
const schema_1 = __importDefault(require("./schema"));
const selectors_1 = __importDefault(require("./slice/selectors"));
const sliceReview_1 = require("./slice/sliceReview");
const constants_1 = require("./slice/sliceReview/constants");
const sliceTemplate_1 = require("./slice/sliceTemplate");
const store_1 = __importStar(require("./store"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const utils_1 = require("./utils");
const supported_file_review_1 = __importDefault(require("../reviews/constants/supported-file-review"));
const initialValuesHandlerDefault = {
    title: '',
    round_type_id: 0,
    inputs: [],
    stages: [],
    adapter_id: 0,
    instruction: '',
};
const ShareReviewSetting = react_1.default.lazy(() => Promise.resolve().then(() => __importStar(require('./components/ShareForReview'))));
const PulseModalReview = (props) => {
    const { onCloseReviewModal, onCreated } = props;
    const formikRef = (0, react_1.useRef)(null);
    const [defaultAdapterId, setDefaultAdapterId] = (0, react_1.useState)(0);
    const [defaultSourceTypeId, setDefaultSourceTypeId] = (0, react_1.useState)(0);
    const [initialValuesHandler, setInitialValuesHandler] = (0, react_1.useState)(initialValuesHandlerDefault);
    const sourceTypes = (0, react_1.useRef)();
    const { title, isOpen, phase, round, currentStage, titleReview, roundStages, assetIds, method, url, mode, ticketId, defaultStatusCalculation, madeDecisionStatusCalculation, instruction, assetsInfo, } = (0, react_redux_1.useSelector)(selectors_1.default);
    const setSourceTypeId = (0, react_1.useCallback)(() => {
        var _a;
        if (!sourceTypes.current)
            return;
        const sourceType = (0, find_1.default)(sourceTypes.current, (source) => {
            if ((0, helper_1.isUrlSourceType)(round, currentStage, url)) {
                return source.name === url.type;
            }
            return source.name === 'asset';
        });
        setDefaultSourceTypeId((_a = sourceType === null || sourceType === void 0 ? void 0 : sourceType.id) !== null && _a !== void 0 ? _a : 0);
    }, [JSON.stringify(round === null || round === void 0 ? void 0 : round.source), currentStage, url]);
    (0, react_1.useEffect)(() => {
        var _a;
        const stages = (0, helper_1.parseRequestBodyStage)(roundStages);
        const inputs = () => {
            let sources = assetIds;
            if ((0, helper_1.isUrlSourceType)(round, currentStage, url)) {
                sources = url.urls;
            }
            return sources.map((id) => ({
                source_type_id: defaultSourceTypeId,
                source: id,
            }));
        };
        setInitialValuesHandler({
            title: titleReview,
            round_type_id: (_a = round === null || round === void 0 ? void 0 : round.roundType) === null || _a === void 0 ? void 0 : _a.value,
            stages,
            inputs: inputs(),
            adapter_id: defaultAdapterId,
            instruction: '',
        });
    }, [
        titleReview,
        roundStages,
        defaultSourceTypeId,
        defaultAdapterId,
        round,
        defaultStatusCalculation,
        madeDecisionStatusCalculation,
    ]);
    (0, react_1.useEffect)(() => {
        try {
            utils_1.v2EndpointCustom.get(`/v2/api/round-adapters`).then((res) => {
                const roundAdapters = (0, utilities_1.parseJsonApi)(res === null || res === void 0 ? void 0 : res.data);
                const roundAdapterDefault = (0, find_1.default)(roundAdapters, (adapter) => {
                    return adapter.name === 'ziflow';
                });
                setDefaultAdapterId(roundAdapterDefault.id);
            });
        }
        catch (error) {
            utilities_1.default.notification.danger(error);
        }
        return () => {
            setDefaultAdapterId(0);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        try {
            pulse_components_1.v2Endpoint.get(`/v2/api/source-types`).then((res) => {
                sourceTypes.current = (0, utilities_1.parseJsonApi)(res === null || res === void 0 ? void 0 : res.data);
                setSourceTypeId();
            });
        }
        catch (error) {
            utilities_1.default.notification.danger(error);
        }
        return () => {
            setDefaultSourceTypeId(0);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        setSourceTypeId();
    }, [currentStage, url.type, isOpen, JSON.stringify(round === null || round === void 0 ? void 0 : round.source)]);
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    // this action will update histories phase
    (0, react_1.useEffect)(() => {
        dispatch((0, sliceReview_1.updateHistoryPhase)());
    }, [phase]);
    const handleClose = (e = {}, reason = '') => {
        if (reason === 'backdropClick') {
            return;
        }
        const reviewModalContainer = document.querySelector('#review-modal');
        if (reviewModalContainer) {
            const reviewModalRoot = (0, client_1.createRoot)(reviewModalContainer);
            if (reviewModalRoot) {
                reviewModalRoot.unmount();
            }
        }
        if ((0, lodash_1.isFunction)(onCloseReviewModal)) {
            onCloseReviewModal();
        }
        dispatch((0, sliceReview_1.closeModal)());
        dispatch((0, sliceTemplate_1.closeTemplate)());
    };
    const getTitleModal = (0, react_1.useMemo)(() => {
        let subTitle = constants_1.TITLE[phase];
        let titleModal = [title, subTitle];
        switch (phase) {
            case constants_1.PHASE.updateTemplate:
            case constants_1.PHASE.savingTemplate:
            case constants_1.PHASE.templateSettings:
            case constants_1.PHASE.reviewing:
                titleModal = [subTitle];
                break;
            case constants_1.PHASE.confirmCreateNewRound: {
                const roundNumber = (round === null || round === void 0 ? void 0 : round.last_round_number) + 1 || 1;
                subTitle = `round ${roundNumber}`;
                titleModal = [title, subTitle];
                break;
            }
            default:
                titleModal = [title, subTitle];
                break;
        }
        return titleModal.join(': ');
    }, [title, phase]);
    const getIconModal = (0, react_1.useMemo)(() => {
        switch (phase) {
            case constants_1.PHASE.savingTemplate:
                return 'fal fa-save';
            case constants_1.PHASE.updateTemplate:
                return 'fal fa-cog';
            default:
                return 'fal fa-share-alt';
        }
    }, [phase]);
    const validateSupportAsset = () => {
        if (!(assetsInfo === null || assetsInfo === void 0 ? void 0 : assetsInfo.length)) {
            return Promise.resolve();
        }
        const unsupportedAsset = assetsInfo.some((asset) => {
            const fileName = asset.title.split('.');
            const extension = fileName.pop();
            return extension && !supported_file_review_1.default.includes(extension);
        });
        if (unsupportedAsset) {
            const error = new Error(' File format not supported.');
            error.name = 'Proof failed';
            return Promise.reject(error);
        }
        return Promise.resolve();
    };
    return (react_1.default.createElement(formik_1.Formik, { enableReinitialize: true, initialValues: initialValuesHandler, onSubmit: async (values) => {
            try {
                await validateSupportAsset();
                // update
                if (method === constants_1.METHOD.updateReview && mode === constants_1.MODE.update) {
                    const requestBody = (0, helper_1.parseRequestBodyRound)(values, store_1.default.getState().review);
                    dispatch((0, sliceReview_1.updateRound)(requestBody)).then((res) => {
                        var _a, _b, _c;
                        if (res.payload) {
                            const updatedRound = (0, utilities_1.camelizeKeys)((_c = (_b = (_a = res.payload) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.attributes);
                            const updateNewRoundEvent = new CustomEvent('update-review-round', {
                                detail: updatedRound,
                            });
                            document.dispatchEvent(updateNewRoundEvent);
                        }
                        utilities_1.default.unblockPage();
                        const updateInstructionsEvent = new CustomEvent('update-instructions', {
                            detail: instruction,
                        });
                        document.dispatchEvent(updateInstructionsEvent);
                        handleClose();
                    });
                }
                // create
                else {
                    const requestBody = (0, helper_1.parseRequestBodyReview)(values, store_1.default.getState().review);
                    dispatch((0, sliceReview_1.saveReview)({ review: requestBody, ticketId })).then(({ payload }) => {
                        utilities_1.default.unblockPage();
                        const { rounds } = payload;
                        const lastIndexRound = (rounds === null || rounds === void 0 ? void 0 : rounds.length) || 0;
                        // reload grid events
                        const reloadGridEvent = new CustomEvent('reload-review-grid', {
                            detail: {
                                status: 200,
                            },
                        });
                        // re-fetch review detail when updated new round
                        const loadReviewDetailEvent = new CustomEvent('reload-review-detail', {
                            detail: rounds[lastIndexRound - 1].id || 0,
                        });
                        document.dispatchEvent(reloadGridEvent);
                        document.dispatchEvent(loadReviewDetailEvent);
                        // Reload the grid in Task Form when creating first Review
                        (0, lodash_1.isFunction)(onCreated) && onCreated();
                        handleClose();
                    });
                }
            }
            catch (error) {
                utilities_1.default.notification.danger(error);
            }
        }, validationSchema: schema_1.default, innerRef: formikRef }, (propsFormik) => {
        const handleNotifyLeastOneReviewer = () => {
            var _a, _b;
            const haveNotReviewerStage = (_b = (_a = propsFormik === null || propsFormik === void 0 ? void 0 : propsFormik.errors) === null || _a === void 0 ? void 0 : _a.stages) === null || _b === void 0 ? void 0 : _b.some((stage) => stage === null || stage === void 0 ? void 0 : stage.reviewers);
            if (haveNotReviewerStage)
                utilities_1.default.notification.danger(notification_1.default.requireReviewer);
        };
        const handleNotifyMaxInstructionLength = () => {
            var _a;
            const maxLength = (_a = propsFormik === null || propsFormik === void 0 ? void 0 : propsFormik.errors) === null || _a === void 0 ? void 0 : _a.instruction;
            if (maxLength) {
                utilities_1.default.notification.danger('Character limit of 2000 reached.');
            }
        };
        const handleDeadlineError = () => {
            var _a, _b;
            const hasDeadlineError = (_b = (_a = propsFormik === null || propsFormik === void 0 ? void 0 : propsFormik.errors) === null || _a === void 0 ? void 0 : _a.stages) === null || _b === void 0 ? void 0 : _b.some((stageError) => stageError === null || stageError === void 0 ? void 0 : stageError.deadline);
            if (hasDeadlineError) {
                utilities_1.default.notification.danger('Due date on the previous Round has passed. Please update this to proceed to the next Round.');
            }
        };
        (0, react_1.useEffect)(() => {
            handleNotifyLeastOneReviewer();
            handleNotifyMaxInstructionLength();
            handleDeadlineError();
        }, [propsFormik === null || propsFormik === void 0 ? void 0 : propsFormik.errors]);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(pulse_components_1.PulseModalBase, { ...props, open: isOpen, onModalClose: handleClose, headerPrimaryText: getTitleModal, classes: {
                    root: [styles_modules_less_1.default['review-modal__body']],
                    dialog: {
                        paper: styles_modules_less_1.default['review-modal__root'],
                    },
                }, PulseModalHeaderProps: {
                    classes: {
                        root: styles_modules_less_1.default['modal-header__root'],
                        titleContainer: styles_modules_less_1.default['modal-header__ctn'],
                        titlePrimary: styles_modules_less_1.default['modal-header__title'],
                        closeBtn: styles_modules_less_1.default['modal-header__closeBtn'],
                    },
                    headerIconClasses: (0, clsx_1.default)(phase !== constants_1.PHASE.savingTemplate
                        ? styles_modules_less_1.default['modal-header__icon']
                        : styles_modules_less_1.default['modal-header__saveicon'], getIconModal),
                }, footer: phase !== constants_1.PHASE.confirmCreateNewRound, footerComponent: react_1.default.createElement(FooterComponent_1.default, { formikProps: propsFormik, handleNotifyLeastOneReviewer: handleNotifyLeastOneReviewer, handleNotifyMaxInstructionLength: handleNotifyMaxInstructionLength }), variant: "jqconfirm" },
                react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default['modal-content__root']) }, phase === constants_1.PHASE.reviewing ? (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null, "Loading...") },
                    react_1.default.createElement(ShareReviewSetting, { formikProps: propsFormik }))) : (react_1.default.createElement(CreateReviewContent_1.default, null))))));
    }));
};
PulseModalReview.displayName = 'PulseModalReview';
exports.default = PulseModalReview;
